<template lang="pug">
v-container(fluid class="tw-p-0 tw-m-0")
  div(class="tw-rounded-md tw-border tw-border-blueGray-lighten-4 px-3")
    v-row(no-gutters align="center" justify="space-between" class="tw-mx-4")
      v-col(cols="7")
        v-row(no-gutters align="center")
          v-col(cols="auto" class="tw-mb-1 tw-ml-1")
            a(@click="download" class="tw-font-medium tw-text-base tw-capitalize ") {{ item.name }}
      v-spacer
      v-col(cols="2" class=" tw-text-right tw-pr-1")
        span {{ this.$moment(item.updated_at).fromNow() }}
      v-spacer
      v-col(cols="auto")
        v-btn(
          :ripple="false"
          icon
          elevation="0"
          color=" blue-grey lighten-1"
          @click="remove"
        )
          v-icon mdi-trash-can-outline
</template>
<script>
export default {
  props: ['item'],
  data() {
    return {
      tempURL: null,
    };
  },
  methods: {
    async download() {
      await this.$store
        .dispatch('opportunities/files/show', [this.$route.params.id, this.item.id])
        .then((res) => {
          this.forceFileDownload(res, this.item.name);
        })
        .catch((error) => {
          this.$store.commit('SET_ERROR', error, { root: true });
        });
    },
    forceFileDownload(response, title) {
      const link = document.createElement('a');
      link.href = response.data;
      link.setAttribute('download', title);
      document.body.appendChild(link);
      link.click();
    },
    remove() {
      this.$store
        .dispatch('opportunities/files/delete', [this.$route.params.id, this.item.id])
        .then((response) => {
          this.$emit('removedItem');
        })
        .catch((error) => {
          commit('SET_ERROR', error, { root: true });
        });
    },
  },
};
</script>
